// Game
export const RESET_GAME = 'RESET_GAME';

export const GET_GAME = 'GET_GAME';
export const WAITING_ANSWER = 'WAITING_ANSWER';
export const ANSWER_REVISION = 'ANSWER_REVISION';


// WEBPACK FOOTER //
// ./src/actions/game-actions.js